.button {
  margin: var(--core-metrics-spacing-400) 0 0;
  width: 100%;
}

.container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.description {
  margin: var(--core-metrics-spacing-200) 0 0;
}

.icon {
  width: 54px;
  height: 54px;

  &.grey path {
    fill: var(--core-fill-30-color);
  }
}

.title {
  margin: var(--core-metrics-spacing-400) 0 0;
}

/*
 * css var are not supported in media queries
 * --core-horizontal-size-class-regular-threshold: 600px
 */
@media screen and (min-width: 600px) {
  .button {
    width: unset;
  }
}
